import { inject } from '@angular/core';
import { UrlTree, Router, CanActivateChildFn } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';

import { BaseDataSource, BaseDataSources, BaseDataService } from 's1m-angular-common-lib';

import { AccessEventsService } from 'src/app/auth/services/access-events.service';
import { RolesService } from 'src/app/auth/services/roles.service';
import { environment } from 'src/environments/environment';
import { BranchesService } from '../services/branches.service';
import { LanguagesService } from '../services/languages.service';
import { TypesService } from '../services/types.service';
import { StatusesService } from '../services/statuses.service';

export const baseDataGuard: CanActivateChildFn = () => {
  const baseDataSources: BaseDataSources = {
    languages: new BaseDataSource(inject(LanguagesService).getList()),
    roles: new BaseDataSource(inject(RolesService).getList()),
    branches: new BaseDataSource(inject(BranchesService).getList()),
    types: new BaseDataSource(inject(TypesService).getList(), inject(TypesService).organizeTypesByGroup),
    statuses: new BaseDataSource(inject(StatusesService).getList(), inject(StatusesService).organizeTypesByGroup),
  };
  return inject(BaseDataService).isBaseDataSet || loadBaseData(baseDataSources);
};

const loadBaseData = (baseDataSources: BaseDataSources): Observable<boolean | UrlTree> => {
  const accessEventsService = inject(AccessEventsService);
  const router = inject(Router);
  return inject(BaseDataService)
    .load(baseDataSources)
    .pipe(
      map(() => true),
      catchError((error) => {
        accessEventsService.logout();
        if (!environment.production) {
          console.error(error.message);
        }
        return of(router.parseUrl('/login'));
      }),
    );
};
